import { WeddingMainContent, Wedding } from "../../types/wedding";
import { generateAPI } from "../api.generator";

export const updateMainContent = generateAPI<
  {
    body: WeddingMainContent;
  },
  Wedding
>("put", "wedding/main-content", "wedding/");
